export const getPriceFormatted = (price) => {
  return price ? price?.toFixed(2) : "0.00";
};
